'use client';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';

export default function MdParser({ content }: { content: string }) {
  return (
    <div className="space-y-8 p-6" data-md>
      {/* max-w-none: prose 의 65ch 제한만 푼다. 예전 max-w-[100vw] 는 좁은 곳(한글 작업창 가입 화면)에서
          글상자보다 넓어져 가로로 넘쳤다. */}
      <div className="prose prose-stone dark:prose-invert max-w-none break-words">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    </div>
  );
}
